import { useEffect } from 'react';
import { trackPageView } from '../utils/analytics';

// Bir bileşen/sekme görünür olduğunda (mount ya da `name` değiştiğinde, ör. sekme geçişinde) bir
// GA4 page_view olayı gönderir. `active` false ise hiçbir şey göndermez — koşullu render edilen
// pencereler için (ör. bir modal sadece açıkken bunu çağırmalı).
export default function useTrackPageView(name, active = true) {
  useEffect(() => {
    if (active) trackPageView(name);
  }, [name, active]);
}
